import {
  faEllipsisV,
  faShare,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import ShareCompanyCultureVideo from "./ShareCompanyCultureVideo";
import DeleteCompanyCultureVideo from "./DeleteCompanyCultureVideo";
const { default: ClickAwayListener } = require("react-click-away-listener");

const VideoActions = ({
  videoId,
  setReload,
  isAudio = false,
  isDocument = false,
  isForwarded = false,
}) => {
  const [openActions, setOpenActions] = useState(false);
  const [key, setKey] = useState("");
  const [openModal, setOpenModal] = useState(false);

  if (isForwarded) {
    return null;
  }

  return (
    <div className="moreActions">
      <div class="dropdown">
        <p
          onClick={() => {
            setOpenActions(!openActions);
          }}
        >
          <FontAwesomeIcon icon={faEllipsisV} />
        </p>

        {openActions && (
          <div
            class={`dropdown-menu ${openActions ? `show` : `hide`}`}
            aria-labelledby="dropdownMenu2"
          >
            <ClickAwayListener onClickAway={() => setOpenActions(!openActions)}>
              <div className="moreMenuVideos">
                {!isForwarded && (
                  <div
                    className="moreMenuVideosItem"
                    onClick={() => {
                      setKey("Share");
                      setOpenModal(true);
                      setOpenActions(false);
                    }}
                  >
                    <FontAwesomeIcon icon={faShare} />
                    Share
                  </div>
                )}
                <div
                  className="moreMenuVideosItem"
                  onClick={() => {
                    setKey("Delete");
                    setOpenModal(true);
                    setOpenActions(false);
                  }}
                >
                  <FontAwesomeIcon icon={faTrash} />
                  Delete
                </div>
              </div>
            </ClickAwayListener>
          </div>
        )}
      </div>

      {openModal && key === "Share" && (
        <ShareCompanyCultureVideo
          onClose={() => {
            setOpenModal(false);
            setKey("");
          }}
          videoId={videoId}
        />
      )}

      {openModal && key === "Delete" && (
        <DeleteCompanyCultureVideo
          onClose={() => {
            setOpenModal(false);
            setKey("");
          }}
          videoId={videoId}
          setReload={setReload}
          isAudio={isAudio}
          isDocument={isDocument}
        />
      )}
    </div>
  );
};

export default VideoActions;
